<script>
import * as moment from 'moment'
import LineChart from '@/charts/components/LineChart.vue';

export default {
  components: {
    LineChart,
  },

  filters: {
    sumOfMortalities(record) { return record.collection_records ? record.collection_records.reduce((total, colRec) => total + colRec.mortalities, 0) : 0 },
  },

  props: {
    batch: { type: Object, required: true },
    fromDate: { type: String },
    toDate: { type: String },
  },

  computed: {
    title() { return `Chicken weights ${this.batch.name} (kg)` },
    options() { return { maintainAspectRatio: false }; },

    chartData() {
      let points = this.recordsInDateRange.map(x => ({
        label: `${x.age_in_weeks}wk / ${x.age_in_days}d`,
        averageWeight: x.average_weight ? Number(x.average_weight) : null,
      }));

      return {
        labels: points.map(x => x.label),
        datasets: [
          {
            label: `${this.batch.name} kg`,
            backgroundColor: 'blue',
            borderColor: 'blue',
            pointHitRadius: 10,
            data: points.map(x => x.averageWeight),
            fill: false,
            spanGaps: true,
            borderWidth: 1.5,
            pointRadius: 1,
          },
        ]
      }
    },

    recordsInDateRange() {
      return this.batch.records.filter(x =>
        (!this.fromDate || moment(this.fromDate).isSameOrBefore(moment(x.date))) &&
        (!this.toDate || moment(this.toDate).isSameOrAfter(moment(x.date))
        ))
    },

    hasRecordsButNoneInRange() { return this.batch.records && this.batch.records.length > 0 && this.recordsInDateRange.length === 0 },
  },
}
</script>

<template>
  <div>
    <div v-if="hasRecordsButNoneInRange">
      <div class="text-warning text-center h4">
        There are records but none are in the date range you picked above.
      </div>
    </div>

    <line-chart
      :chart-data="chartData"
      :options="options"
      :x-axis-ticks-min-rotation="60"
      :x-axis-ticks-max-rotation="60"
      :chart-title="title"
      x-axis-label="kg"
      y-axis-label="Average weight" />
  </div>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/StockWeightsChart.vue